module.exports = __webpack_public_path__ + "static/media/healthy.fcd3ff2f.svg";